import {message} from 'antd';
import {postExcelDownLoadAPI} from 'api/common';
import {IconExcel, IconFileImage, IconFilePdf} from 'components/assets/icons';
import { useEffect } from 'react';
import {utils, writeFile} from 'xlsx';
import * as XLSX from "xlsx-js-style";

const borderStyle = {
    style: "thin", // 테두리 스타일 (thin, medium, thick 등)
    color: { rgb: "000000" }, // 검은색 테두리
  };

const headerStyle = {
  font: { bold: true},
  fill: { fgColor: { rgb: "CCCCCC" } },
  alignment: { horizontal: "center" },
  border: { top: borderStyle, bottom: borderStyle, left: borderStyle, right: borderStyle },
};  
const cellStyle = {
  alignment: { horizontal: "center" },
  border: { top: borderStyle, bottom: borderStyle, left: borderStyle, right: borderStyle },
};

export const fileExtensions = (fileName, onClick) => {
  if (fileName) {
    const split = fileName.split('.');
    const type = split[split.length - 1];
    if (type === 'pdf') return <IconFilePdf onClick={() => alert('Pdf 파일 다운로드')}/>;
    if (/^xl/i.test(type)) return <IconExcel onClick={() => alert('Excel 파일 다운로드')}/>;
    if (/(jpg|jpeg|png|gif|bmp)$/i.test(type)) return <IconFileImage onClick={onClick}/>;
  }
};

export const getFileExtensions = (fileName, onClick) => {
  if (fileName) {
    const split = fileName.split('.');
    const type = split[split.length - 1];
    if (type === 'pdf') return <IconFilePdf onClick={() => onClick(type)} />;
    if (/^xl/i.test(type)) return <IconExcel onClick={() => onClick(type)}/>;
    if (/(jpg|jpeg|png|gif|bmp)$/i.test(type)) return <IconFileImage onClick={()=>onClick('img')}/>;
  }
};

export const utilExcelDownload = async (file, fileName) => {
  try {
    const sendData = {
      fileName: fileName,
      list: file
    };

    const {data} = await postExcelDownLoadAPI(sendData);
    if (data) {
      message.info('엑셀 다운로드 중입니다.');
      const link = document.createElement('a');
      link.href = data?.url_path;
      link.setAttribute('download', data?.original_file_name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (err) {
    alert('서버 통신오류입니다.');
    console.error(err);
  }
};

// header순서랑 list 데이터 순서가 맞아야함
export const exportExcelDownload = (header, list, menu) => {
  const excelHeader = [header];
  let exportList = list;
  const wb = utils.book_new();

  const ws = utils.json_to_sheet([]);

  utils.sheet_add_aoa(ws, excelHeader);

  utils.sheet_add_json(ws, exportList, {origin: 'A2', skipHeader: true});
  utils.book_append_sheet(wb, ws, 'Report');
  writeFile(wb, `${menu}.xlsx`);
  exportList = [];
};

// header순서랑 list 데이터 순서가 맞아야함, 스타일적용 테스트중
export const exportStyleExcelDownload = (header, list, menu) => {
  
  const excelHeader = [header];
  let exportList = list;
  const wb = utils.book_new();
  const ws = utils.json_to_sheet([]);

  const cellHeader = header.map(it=>({v:it, s:headerStyle}))
  const cellData = 
    list.map(el =>{
      const cell = Object.values(el);
      return cell.map(it=> ({v: it !== undefined ? (it !== null?it:'') : '', s:cellStyle}));
    })
  const worksheet = XLSX.utils.aoa_to_sheet([cellHeader,...cellData]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "StyledSheet");
  XLSX.writeFile(workbook, `${menu}.xlsx`);
  

  // utils.sheet_add_aoa(ws, excelHeader);
  // utils.sheet_add_json(ws, exportList, {origin: 'A2', skipHeader: true});
  // utils.book_append_sheet(wb, ws, 'StyledSheet');
  // writeFile(wb, `${menu}.xlsx`);
  exportList = [];
};


export const exportMergeExcelDownload = (header, list, menu) => {
  let exportList = list;
  const wb = utils.book_new();

  const ws = utils.json_to_sheet([]);

  utils.sheet_add_aoa(ws, header);
  let startCell = 0
  const merges = []
  header[0].forEach((el, idx) => {
    if (idx !== 0 && el !== '') {
      merges.push({s: {r: 0, c: startCell}, e: {r: 0, c: idx - 1}})
      startCell = idx
    }
    if (idx === header[0].length - 1) {
      merges.push({s: {r: 0, c: startCell}, e: {r: 0, c: idx}})
    }
  })
  ws['!merges'] = merges

  utils.sheet_add_json(ws, exportList, {origin: 'A3', skipHeader: true});
  utils.book_append_sheet(wb, ws, 'Report');
  writeFile(wb, `${menu}.xlsx`);
  exportList = [];
};
